
/**
 * @param {string|boolean} query
 * @returns {MediaQueryList}
 */
export function getMediaQuery(query) {
  if (query === true) {
    return window.matchMedia('all');
  }

  if (query === false) {
    return window.matchMedia('not all');
  }

  return window.matchMedia(query);
}